const DEVICE_MAP_KEY = "yunmei_ble_devices";

function getDeviceMap() {
    try {
        return JSON.parse(localStorage.getItem(DEVICE_MAP_KEY) || "{}");
    } catch (e) {
        return {};
    }
}

function saveDeviceMap(map) {
    try {
        localStorage.setItem(DEVICE_MAP_KEY, JSON.stringify(map));
    } catch (e) {
        console.warn("保存蓝牙设备信息失败", e);
    }
}

export function getRememberedDeviceId(lockKey) {
    return getDeviceMap()[lockKey] || "";
}

export function rememberDevice(lockKey, device) {
    const map = getDeviceMap();
    if (map[lockKey] !== device.id) {
        map[lockKey] = device.id;
        saveDeviceMap(map);
    }
}

export async function getDevice(uuid, deviceId) {
    // 优先使用已授权的设备，避免每次弹出选择器
    if (deviceId && navigator.bluetooth.getDevices) {
        try {
            const devices = await navigator.bluetooth.getDevices();
            const remembered = devices.find(device => device.id === deviceId);
            if (remembered) return remembered;
        } catch (e) {
            console.warn("getDevices() 获取已授权设备失败，回退到设备选择", e);
        }
    }
    return navigator.bluetooth.requestDevice({ filters: [{ services: [uuid.toLowerCase()] }] });
}

export function getCharacteristic(device, serviceUuid, characteristicUuid) {
    return device.gatt.connect()
        .then(server => server.getPrimaryService(serviceUuid.toLowerCase()))
        .then(service => service.getCharacteristic(characteristicUuid.toLowerCase()));
}

export function writeCharacteristic(characteristic, data) {
    // 新版 Web Bluetooth API：writeValue 已废弃
    if (typeof characteristic.writeValueWithResponse === "function") {
        const props = characteristic.properties || {};
        if (props.writeWithoutResponse && !props.write) {
            return characteristic.writeValueWithoutResponse(data);
        }
        return characteristic.writeValueWithResponse(data);
    }
    // 旧浏览器回退
    return characteristic.writeValue(data);
}